import { Link, useLocation } from 'react-router-dom'

import Icon from 'components/UI/Icon'

const DashboardNavbarItem = ({ href, label, icon }) => {
  const location = useLocation()

  const isActive = location.pathname.includes(href)

  return (
    <li>
      <Link
        className="inline-flex items-center justify-center text-white h-[40px] px-[10px] rounded-md hover:bg-primary-150 group"
        to={href}
      >
        <Icon className={`mr-[8.5px] ${!isActive ? 'opacity-70' : ''}`} name={icon} />
        <span className={`${!isActive ? 'opacity-90' : ''}`}>{label}</span>
      </Link>
    </li>
  )
}

export default DashboardNavbarItem
